import { SET_CURRENT_USER, LOADING, GET_USERS, GET_USER_BY_ID, SUCCESS_MESSAGE, RESET_PWD_SUCCESS, NOT_ACTIVE } from "../actions/types";
import isEmpty from "lodash/isEmpty";

const initialState = {
    isAuthenticated: false,
    user: {},
    loading: false,
    users: [],
    userById: {},
    success: false,
    notActive: false
};

export default function authReducer(state = initialState, action = {}) {
    switch (action.type) {
        case LOADING:
            return {
                ...state,
                loading: true
            };
        case SET_CURRENT_USER:

            if (action.payload.orgId != undefined) {

            }
            else {
                action.payload.orgId = 1;
            }

            return {
                ...state,
                isAuthenticated: !isEmpty(action.payload),
                user: action.payload,
                loading: false,
                success: false
            };
        case GET_USERS:
            return {
                ...state,
                users: action.payload,
                loading: false
            };
        case GET_USER_BY_ID:
            return {
                ...state,
                userById: action.payload,
                loading: false
            };
        case SUCCESS_MESSAGE:
            return {
                ...state,
                success: true
            };
        case RESET_PWD_SUCCESS:
            return {
                ...state,
                message: action.payload,
                success: true,
                loading: true,
            };
        case NOT_ACTIVE:
            return {
                ...state,
                notActive: true
            };
        default:
            return state;
    }
}
